<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      redirect: ''
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  async mounted() {
    if ('token' in this.$route.query) {
      await this.$store.dispatch('initToken', this.$route.query.token)
    }
    this.$router.push({ path: this.redirect || '/error' })
  }
}
</script>